module.exports = __webpack_public_path__ + "static/bark-3fcb6b6298cae46f0e7755260af23e6f.gif";